import { TRANSLATED_ACTIONS } from '@/common/messages';
import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Files = defineMessages({
  uploadFiles: {
    id: 'app.containers.Records.Form.uploadFiles',
    defaultMessage: 'Přeneste soubory nebo klikněte do této oblasti.',
  },
});

export const Establishments = defineMessages({
  default: {
    id: 'app.components.TreeSelect.Establishments.default',
  },
});

export const SupplyPoints = defineMessages({
  establishment: APP_DICTIONARY.establishment,
  contract: APP_DICTIONARY.contract,
  code: {
    id: 'app.components.form.Dropdown.code',
  },
  registrationNumber: APP_DICTIONARY.registrationNumber,
  placeholder: {
    id: 'app.components.Filter.SupplyPoints.placeholder',
  },
});

export const Select = defineMessages({
  placeholder: TRANSLATED_ACTIONS.select,
});
